export const GET_CONFIGURATION_VIEWS = 'getConfigurationViews'
export const SAVE_CONFIGURATION_VIEW = 'saveConfigurationView'
export const DELETE_CONFIGURATION_VIEW = 'deleteConfigurationView'
export const UPDATE_CONFIGURATION_VIEW = 'updateConfigurationView'

export const TAG_CONFIGURATION_VIEWS = 'CONFIGURATION_VIEWS'
export default [TAG_CONFIGURATION_VIEWS]
